export enum ETriggerId {
  RegistrationComplete = 'registrationComplete',
  EmailBlocked = 'emailBlocked',
  DepositSuccess = 'depositSuccess',
  CashoutSuccess = 'cashoutSuccess',
  CashoutFail = 'cashoutFail',
  FreespinsAvailable = 'freespinsAvailable',
  TournamentStartingSoon = 'tournament_starts_soon',
  TournamentStarted = 'tournament_started',
  PlayerKickedFromLeaderboard = 'player_kicked_from_leaderboard',
  ERROR_1 = 'ERROR_1',
  ERROR_2 = 'ERROR_2',
  ERROR_3 = 'ERROR_3',
  ERROR_4 = 'ERROR_4',
  ERROR_5 = 'ERROR_5',
  ERROR_6 = 'ERROR_6',
  ERROR_7 = 'ERROR_7',
  ERROR_8 = 'ERROR_8',
  ERROR_9 = 'ERROR_9',
  ERROR_10 = 'ERROR_10',
  ERROR_11 = 'ERROR_11',
  ERROR_12 = 'ERROR_12',
  ERROR_13 = 'ERROR_13',
  ERROR_14 = 'ERROR_14',
  ERROR_15 = 'ERROR_15',
}

export enum EToastType {
  Success = 'success',
  Error = 'error',
  Info = 'info',
}

export enum EToastPlacement {
  Top = 'top',
  Bottom = 'bottom',
}

export interface IToast {
  id: number;
  triggerId: ETriggerId | 'custom';
  title: string;
  message: string;
  type: EToastType;
  duration: number;
  placement: EToastPlacement;
  isAvailableInGamePage: boolean;
  isAvailableInCashier: boolean;
  groupToAddOnRead?: string;
  groupFilter?: {
    includedGroups: string;
    excludedGroups: string;
  } | null;
}
export interface ICustomToast {
  title: string;
  message: string;
  type: EToastType;
  duration: number;
  placement?: EToastPlacement;
  isAvailableInGamePage?: boolean;
  isAvailableInCashier?: boolean;
}

export interface IToastsStrapiResponse {
  data: IToast[];
}

export interface IToastAddOptions {
  preMessage?: string;
  postMessage?: string;
  isGTM?: boolean;
}
